import { render, staticRenderFns } from "./SectionHeader.vue?vue&type=template&id=37b40436&scoped=true&"
import script from "./SectionHeader.vue?vue&type=script&lang=js&"
export * from "./SectionHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b40436",
  null
  
)

export default component.exports